import React from "react";

import { Helmet } from "react-helmet";

import { isWebView } from "@/utils/env";

const WebViewStyleHelmet = () =>
  (
    isWebView() ? (
      <Helmet>
        <style>
          {`.dont-show-in-web-view { display: none; }`}
        </style>
      </Helmet>
    ) : null
  );

export default WebViewStyleHelmet;
